// extracted by mini-css-extract-plugin
export default {"createSeasonButton":"CreateNewSeason_createSeasonButton__+nbV5"};